import {useCallback} from 'react';
import {Typography} from '~library/atoms/Typography';
import {OptionBlock} from './OptionBlock/OptionBlock';

type PartyTipsProps = {
  isActive: boolean;
  onChange: (value: boolean) => void;
};

export const PartyTips = ({isActive, onChange}: PartyTipsProps) => {
  const onChangeHandler = useCallback((value: boolean) => onChange(value), [onChange]);

  return (
    <OptionBlock
      title="Get party tips from Evite"
      isActive={isActive}
      onToggleClickHandler={onChangeHandler}
      dataQaId="join-the-club"
    >
      <Typography variant="paragraph3" color="pebble">
        We’ll send you hosting advice from our experts, trending party ideas, and more!
      </Typography>
    </OptionBlock>
  );
};
